import { Spinner } from '@repo/ui'
import { action, runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { apiClient } from '@/api/api-client'
import StoreService from '@/store/StoreService'

import { EditTriviaList } from './edit-trivia-list'
import { useQueryUserTriviaList } from '../queries/useQueryUserTriviaList'
import { useUpdateUserTriviaList } from '../queries/useUpdateUserTriviaList'
import { useUserTriviaListImageStorageFolder } from '../queries/useUserTriviaListImageStorageFolder'

interface RouteParams {
  listId: string
}

export const EditTriviaListRoute = observer(() => {
  const { listId } = useParams<RouteParams>()
  const { data, isLoading, isSuccess } = useQueryUserTriviaList(listId)
  const [isStartingGame, setIsStartingGame] = useState(false)
  const store = StoreService.getStore()
  const history = useHistory()

  const storageFolder = useUserTriviaListImageStorageFolder()

  const { isLoading: isSaving, mutate: updateUserTriviaList } = useUpdateUserTriviaList({
    listId
  })

  if (isLoading) return <Spinner />

  if (!isSuccess) return null

  const handleClickStartGame = action(async () => {
    setIsStartingGame(true)

    runInAction(() => {
      store.isLoadingGame = true
    })

    await apiClient.createGame({ triviaList: data, type: 'trivia' })

    history.push('/game/setup/gameplay')

    setIsStartingGame(false)
  })

  return (
    <EditTriviaList
      data={data}
      imageStorageFolder={storageFolder}
      isSaving={isSaving}
      isStartingGame={isStartingGame}
      updateTriviaList={updateUserTriviaList}
      onStartGame={handleClickStartGame}
    />
  )
})
